import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapResponse, unwrapErrorResponse } from '@/utils/unwrapResponse'
import {
  APIErrorResponse,
  QuotationPaymentTerm,
  PostQuotationPaymentTerm,
} from '@/types'

export const usePostQuotationPaymentTerm = (
  quotationId: number
): UseMutationResult<
  QuotationPaymentTerm,
  APIErrorResponse,
  PostQuotationPaymentTerm
> => {
  const client = useApiClient()

  return useMutation((params) =>
    client
      .post(`/quotations/${quotationId}/payment_terms/`, params)
      .then(unwrapResponse)
      .catch(unwrapErrorResponse)
  )
}
